module.exports = __webpack_public_path__ + "static/media/meal-bg.80362f36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal-bg.jpg
// module id = 926
// module chunks = 0